module.exports = __webpack_public_path__ + "img/uw_wand.5d07d3cd.jpg";